import {Component, inject} from '@angular/core';
import {ModalService} from '@core/services';
import {PlanForm} from '@core/modals';

@Component({
  selector: 'core-plan-alert',
  imports: [],
  templateUrl: './plan-alert.html',
  styleUrl: './plan-alert.scss',
})
export class PlanAlert {

  private readonly modal = inject(ModalService);
  editPlan() {
    this.modal.open<PlanForm, boolean>(PlanForm, {
      inputs: {},
      outputs: {},
      options: { size: 'md', closeOnBackdrop: false, showCloseButton: false },
    });
  }
}
